import { MockGithubUser } from '../types';

export const defaultUser: MockGithubUser = {
  login: null,
  avatar: 'https://avatars.githubusercontent.com/u/583231?v=4',
  name: null,
  company: null,
  blog: null,
  location: null,
  bio: null,
  twitter: null,
  repos: 0,
  followers: 0,
  following: 0,
  created: null
};
